"use client";

import { c as _c } from "react/compiler-runtime";
import { CopyableContent } from "@/src/components/copyable-content";
import { tryGetEhrSystemId } from "@/src/lib/resolve-ehr-ids";
import { EHRDocument } from "@/src/models/ehr-document";
import { Patient } from "@/src/models/patient";
import { getPersonName } from "@/src/models/person";
interface AthenaPatientInfoHeaderProps {
  title: string;
  patientDetails: Patient | null;
  document: EHRDocument | null;
  documentPatientId?: string | null;
}
export function AthenaPatientInfoHeader(t0) {
  const $ = _c(25);
  const {
    title,
    patientDetails,
    document,
    documentPatientId
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="text-md font-semibold text-center mb-2">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-medium">Patient Name: </span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== patientDetails) {
    t3 = getPersonName(patientDetails, true, true) || "N/A";
    $[3] = patientDetails;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div>{t2}{" "}<CopyableContent text={t3} /></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-medium">EHR ID: </span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== patientDetails) {
    t6 = patientDetails && tryGetEhrSystemId(patientDetails) || "N/A";
    $[8] = patientDetails;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div>{t5}<CopyableContent text={t6} /></div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-medium">Document ID: </span>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = document?.ehrId || "N/A";
  let t10;
  if ($[13] !== t9) {
    t10 = <div>{t8}<CopyableContent text={t9} /></div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t4 || $[17] !== t7) {
    t11 = <div className="grid grid-cols-3">{t4}{t7}{t10}</div>;
    $[15] = t10;
    $[16] = t4;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== documentPatientId) {
    t12 = documentPatientId && <div className="mt-1"><span className="font-medium">EHR ID attached to document: </span><CopyableContent text={documentPatientId} /></div>;
    $[19] = documentPatientId;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t1 || $[22] !== t11 || $[23] !== t12) {
    t13 = <div className="mb-4">{t1}{t11}{t12}</div>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}